import React, { PropsWithChildren } from 'react'
import Styles from './PersistentToast.module.scss'
import { Button } from 'blaze-ui/Button'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { Icon } from 'almanac-ui/icons/Types'

interface ActionProps {
  onPress: () => void
  frontIcon?: Icon
}

export const PrimaryAction = ({ children, onPress, frontIcon }: PropsWithChildren<ActionProps>) => (
  <div className={Styles.primaryAction}>
    <ResponsiveDesign.Desktop>
      <Button variant="secondary" size="sm" onPress={onPress} frontIcon={frontIcon}>
        {children}
      </Button>
    </ResponsiveDesign.Desktop>
    <ResponsiveDesign.Mobile>
      <Button variant="secondary" size="lg" onPress={onPress} fullWidth frontIcon={frontIcon}>
        {children}
      </Button>
    </ResponsiveDesign.Mobile>
  </div>
)

PrimaryAction.displayName = 'PrimaryAction'

export const SecondaryAction = ({ children, onPress, frontIcon }: PropsWithChildren<ActionProps>) => (
  <div className={Styles.secondaryAction}>
    <ResponsiveDesign.Desktop>
      <Button variant="tertiary" size="sm" onPress={onPress} frontIcon={frontIcon}>
        {children}
      </Button>
    </ResponsiveDesign.Desktop>
    <ResponsiveDesign.Mobile>
      <Button variant="tertiary" size="lg" onPress={onPress} fullWidth frontIcon={frontIcon}>
        {children}
      </Button>
    </ResponsiveDesign.Mobile>
  </div>
)

SecondaryAction.displayName = 'SecondaryAction'

export const Actions = ({ children }: PropsWithChildren) => {
  return <div className={Styles.actions}>{children}</div>
}
